import { makeSearch } from "../../UI/Search/Search";
import StageTypeService from "../../../Services/StageType.service";
const makeSearchArgs = {
    loadOptions: (search, options) => StageTypeService.search({
        query: search,
        ids: options === null || options === void 0 ? void 0 : options.ids,
    }).then((result) => result.data),
    label: "name",
    value: "id",
};
export const StageTypeSearch = makeSearch(makeSearchArgs);
